module.exports = __webpack_public_path__ + "static/media/ic_delete.b1fd5725.webp";